import React from "react";
import { Link } from "react-router-dom";
import "../style/Home.css";

const Home = () => {

  return (
    <>
      <div className="main">
        {/* HERO */}
        <div className="hero-section">
          <h1 className="hero-headline">A searchable database of 2,000+ cat food products</h1>
          
          <div className="hero-content-wrapper">
            <div className="hero-text-content">
              <p className="hero-subtext">
                Nutritional data from 30+ manufacturer sources, including specialty and
                hard-to-find brands. Search, filter by 20+ criteria, and compare products
                side by side.
              </p>
              <p className="hero-tagline">
                Free cat food database built by cat parents to help other cat parents.
              </p>
              <p className="hero-subtext">
                Explore the full database, or answer a few questions to get personalized recommendations.
              </p>

              <div className="hero-cta-buttons">
                <button className="hero-button hero-button-primary">
                  <Link to="/Database">Browse the Database</Link>
                </button>
                <button className="hero-button hero-button-secondary">
                  <Link to="/Recommendations">Get Recommendations</Link>
                </button>
              </div>
            </div>
            <div className="hero-logo-container">
              <img 
                src="/picky-kitty/the-picky-kitty.png" 
                alt="The Picky Kitty Logo" 
                className="hero-logo-image"
              />
            </div>
          </div>
        </div>

        <div className="section-divider"></div>

        {/* <div className="content-section">
          <h2 className="section-title">How it works</h2>

          <ul className="bullet-list">
            <li>Save time: 2,000+ products with nutritional data aggregated from manufacturer sources</li>
            <li>Narrow your options: Filter by 20+ criteria, including nutrient levels and health conditions</li>
            <li>Compare with clarity: Detailed ingredients and nutrition breakdowns side by side</li>
            <li>Choose your approach: Explore with advanced filters, or get personalized recommendations</li>
          </ul>

          <p className="trust-note">
            <strong>Not a review site. We don't rate or rank products.</strong><br />
            Just comprehensive data and tools to search, filter, and compare.
          </p>
        </div>

        <div className="section-divider"></div> */}

        {/* FEATURES */}
        <div className="features-section">
          <h2 className="section-title">What you can do</h2>

          <div className="feature-card feature-card-highlighted">
            <h3>Food Database</h3>
            <p>
              Search our database of cat food products with nutritional data extracted from
              manufacturer sources. Filter by 20+ criteria including protein source, texture, health conditions and
              ingredients to avoid.
            </p>
            <button className="feature-button">
              <Link to="/Database">Browse Cat Foods</Link>
            </button>
          </div>

          <div className="feature-card feature-card-highlighted">
            <h3>Recommendations</h3>
            <p>
              Answer a few questions about your cat's age, preferences, and needs to get a tailored shortlist from our database.
            </p>
            <button className="feature-button">
              <Link to="/Recommendations">Get Recommendations</Link>
            </button>
          </div>

          <div className="feature-card">
            <h3>Comparison</h3>
            <p>Compare multiple products side by side with detailed breakdowns of ingredients,
              guaranteed analysis, and key nutritional features.</p>
            <button className="feature-button">
              <Link to="/Comparison">Compare Products</Link>
            </button>
          </div>

          <div className="feature-card">
            <h3>Product Scanner</h3>
            <p>At the store? Scan any product to instantly identify it and see its nutritional information.</p>
            <button className="feature-button">
              <Link to="/Scanner">Scan Products</Link>
            </button>
          </div>

          <div className="feature-card">
            <h3>Nutritional Tools</h3>
            <p>Calculate your cat's daily calorie needs and analyze food on a dry matter basis for accurate comparisons.</p>
            <button className="feature-button">
              <Link to="/Tools">Access Tools</Link>
            </button>
          </div>
        </div>

        <div className="section-divider"></div>

        {/* BEHIND THE SCENES */}
        <div className="content-section">
          <h2 className="section-title">Our story</h2>
          <p>
            The Picky Kitty was built by a data scientist after his picky cat, Ulysse, was diagnosed with chronic kidney disease.
            What started as countless hours digging through manufacturer websites for nutritional data eventually became this database.<br />
            <Link to="/About">Read the full story</Link>
          </p>
        </div>

      </div>
    </>
  );
};

export default Home;
